import { BaseHTMLAttributes, DetailedHTMLProps, FC } from "react"
import { Icon } from "@/ui/Icon"
import { NavigationItem } from "@/ui/Navigation/NavigationItem"
import { BreadcrumbsSeparator, StyledBreadcrumbItem } from "./StyledBreadcrumbs"
import { BreadcrumbItemType } from "./types"

const BreadcrumbItem: FC<
  BreadcrumbItemType &
    DetailedHTMLProps<BaseHTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({
  path,
  title,
  separator = "AngleRight",
  subItems = [],
  isLink = true,
  isScroll = true,
  ...props
}) => {
  return (
    <StyledBreadcrumbItem {...props}>
      <BreadcrumbsSeparator>
        <Icon NameIcon={separator} />
      </BreadcrumbsSeparator>
      <NavigationItem
        title={title}
        subItems={subItems}
        path={path}
        as={"div"}
        isScroll={isScroll}
        isLink={isLink}
        isStylingIconDisclosure={false}
        isShowQty={false}
      />
    </StyledBreadcrumbItem>
  )
}

export type { BreadcrumbItemType }
export default BreadcrumbItem
